import { render, staticRenderFns } from "./Label.vue?vue&type=template&id=4d12ecd1&"
import script from "./Label.vue?vue&type=script&lang=ts&"
export * from "./Label.vue?vue&type=script&lang=ts&"
import style0 from "./Label.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3695298039/src/github.com/trainn-tech/trainn-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d12ecd1')) {
      api.createRecord('4d12ecd1', component.options)
    } else {
      api.reload('4d12ecd1', component.options)
    }
    module.hot.accept("./Label.vue?vue&type=template&id=4d12ecd1&", function () {
      api.rerender('4d12ecd1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lib/form/label/Label.vue"
export default component.exports